import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { RemoteDiagnosticsSnapshotsStore } from '@store';
import { DIAGNOSTICS_CONNECTION_STEP, RemoteDiagnosticsStore } from '@store';

@Component({
  selector: 'app-backup-loader',
  templateUrl: './backup-loader.component.html',
  styleUrls: ['./backup-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackupLoaderComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  readonly modalStep = DIAGNOSTICS_CONNECTION_STEP;
  readonly connectionStep = DIAGNOSTICS_CONNECTION_STEP;

  isAnyFromSnapshotVddLoading: boolean;
  wasAnyFromSnapshotVddLoading: boolean;
  gatewaySerial: string;

  constructor(
    public remoteDiagnosticsSnapshotsStore: RemoteDiagnosticsSnapshotsStore,
    public remoteDiagnosticsStore: RemoteDiagnosticsStore,
    private activatedRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.gatewaySerial = this.activatedRoute.snapshot.queryParams['gatewaySerial'];

    this.remoteDiagnosticsSnapshotsStore.isAnyFromBackupVddListLoading$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((isAnyFromSnapshotVddLoading) => {
        this.isAnyFromSnapshotVddLoading = isAnyFromSnapshotVddLoading;
        if (this.wasAnyFromSnapshotVddLoading && !this.isAnyFromSnapshotVddLoading) {
          this.remoteDiagnosticsSnapshotsStore.setDateOfTheValuesRead();
          this.remoteDiagnosticsSnapshotsStore.showValues();
        }
        if (this.isAnyFromSnapshotVddLoading) {
          this.wasAnyFromSnapshotVddLoading = true;
        }
        this.cdr.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
